<div class="w-full">
  <!-- header (sits on the dark-blue dialog band -> white text) -->
  <div class="mb-2 flex items-center justify-between">
    <h2 class="m-0 text-xl font-semibold text-white">Neuer Eintrag</h2>
    <button
      type="button"
      class="flex h-8 w-8 items-center justify-center rounded-full text-white/70 hover:bg-white/10 hover:text-white"
      (click)="cancel()"
      aria-label="Schließen">
      <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" />
      </svg>
    </button>
  </div>

  <!-- step indicator (pushed below the blue header band) -->
  <div class="mb-7 mt-8 flex items-center">
    <ng-container *ngFor="let s of [1, 2, 3, 4]; let i = index; let last = last">
      <div class="relative flex flex-col items-center">
        <div
          class="flex h-8 w-8 items-center justify-center rounded-full text-sm font-semibold"
          [ngClass]="{
            'bg-green-500 text-white': step > s,
            'bg-blue-600 text-white': step === s,
            'bg-gray-200 text-gray-500': step < s
          }">
          <span *ngIf="step > s">&#10003;</span>
          <span *ngIf="step <= s">{{ s }}</span>
        </div>
        <span
          class="absolute top-9 whitespace-nowrap text-[11px] font-medium"
          [ngClass]="step >= s ? 'text-blue-600' : 'text-gray-400'">
          {{ ['Typ', 'Angaben', 'Bilder', 'Überblick'][i] }}
        </span>
      </div>
      <div
        *ngIf="!last"
        class="mx-1.5 h-0.5 flex-1"
        [ngClass]="step > s ? 'bg-green-500' : 'bg-gray-200'"></div>
    </ng-container>
  </div>

  <!-- body -->
  <div class="min-h-[260px] pt-2">
    <!-- ============================ STEP 1: TYPE ============================ -->
    <div *ngIf="step === 1">
      <p class="mb-4 text-[15px] font-medium text-gray-700">Was möchten Sie anlegen?</p>
      <div class="flex gap-4">
        <button
          type="button"
          class="flex flex-1 flex-col items-center gap-1.5 rounded-xl border-2 bg-white p-6 transition hover:border-blue-300"
          [ngClass]="bom === 0 ? 'border-blue-600 bg-blue-50' : 'border-gray-200'"
          (click)="selectType(0)">
          <svg class="h-9 w-9" [ngClass]="bom === 0 ? 'text-blue-600' : 'text-gray-400'" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
          </svg>
          <span class="text-base font-semibold text-gray-900">Anzeige</span>
          <span class="text-xs text-gray-400">Standard-Anzeige</span>
        </button>
        <button
          type="button"
          class="flex flex-1 flex-col items-center gap-1.5 rounded-xl border-2 bg-white p-6 transition hover:border-blue-300"
          [ngClass]="bom === 1 ? 'border-blue-600 bg-blue-50' : 'border-gray-200'"
          (click)="selectType(1)">
          <svg class="h-9 w-9" [ngClass]="bom === 1 ? 'text-blue-600' : 'text-gray-400'" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 8.25H7.5a2.25 2.25 0 00-2.25 2.25v9a2.25 2.25 0 002.25 2.25h9a2.25 2.25 0 002.25-2.25v-9a2.25 2.25 0 00-2.25-2.25H15M9 12l2.25 2.25L15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z" />
          </svg>
          <span class="text-base font-semibold text-gray-900">BOM</span>
          <span class="text-xs text-gray-400">mit Tatzeitraum</span>
        </button>
      </div>
    </div>

    <!-- ============================ STEP 2: INFO ============================ -->
    <div *ngIf="step === 2">
      <p class="mb-4 text-[15px] font-medium text-gray-700">Angaben zum {{ typeLabel }}</p>
      <form [formGroup]="frm" class="space-y-3">
        <!-- Kennzeichen -->
        <div class="flex gap-3">
          <div class="w-[110px]">
            <label class="mb-1 block text-sm font-medium text-gray-700">Land</label>
            <select formControlName="kzland" class="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500">
              <option value="A">A</option>
              <option *ngFor="let land of stammdaten.lander" [value]="land.bezeichnung">{{ land.bezeichnung }}</option>
            </select>
          </div>
          <div class="w-[120px]">
            <label class="mb-1 block text-sm font-medium text-gray-700">Bezirk</label>
            <input type="text" formControlName="kzbezirk" class="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500" />
          </div>
          <div class="flex-1">
            <label class="mb-1 block text-sm font-medium text-gray-700">Kennzeichen *</label>
            <input type="text" formControlName="kznummer" class="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500" />
          </div>
        </div>

        <!-- Tatort -->
        <div class="flex gap-3">
          <div class="flex-1">
            <label class="mb-1 block text-sm font-medium text-gray-700">Straße (Tatort) *</label>
            <select formControlName="street" class="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500">
              <option value="">- bitte wählen -</option>
              <option *ngFor="let street of stammdaten.streets" [value]="street.bezeichnung">{{ street.bezeichnung }}</option>
            </select>
          </div>
          <div class="w-[110px]">
            <label class="mb-1 block text-sm font-medium text-gray-700">Nr.</label>
            <input type="text" formControlName="streetnbr" class="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500" />
          </div>
        </div>

        <!-- Fahrzeug -->
        <div class="flex gap-3">
          <div class="flex-1">
            <label class="mb-1 block text-sm font-medium text-gray-700">Hersteller</label>
            <select formControlName="hersteller" class="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500">
              <option value="">-</option>
              <option *ngFor="let h of stammdaten.hersteller" [value]="h.bezeichnung">{{ h.bezeichnung }}</option>
            </select>
          </div>
          <div class="flex-1">
            <label class="mb-1 block text-sm font-medium text-gray-700">Farbe</label>
            <select formControlName="farbe" class="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500">
              <option value="">-</option>
              <option *ngFor="let f of stammdaten.farben" [value]="f.bezeichnung">{{ f.bezeichnung }}</option>
            </select>
          </div>
        </div>

        <!-- Tatzeit von -->
        <div class="flex gap-3">
          <div class="flex-1">
            <label class="mb-1 block text-sm font-medium text-gray-700">{{ bom === 1 ? 'Tatzeit von - Datum' : 'Tatdatum' }} *</label>
            <input type="text" inputmode="numeric" placeholder="TT.MM.JJJJ" formControlName="tat_datum" class="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500" />
          </div>
          <div class="w-[130px]">
            <label class="mb-1 block text-sm font-medium text-gray-700">{{ bom === 1 ? 'Uhrzeit von' : 'Uhrzeit' }} *</label>
            <input type="text" inputmode="numeric" placeholder="HH:MM" formControlName="tat_zeit" class="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500" />
          </div>
        </div>

        <!-- Tatzeit bis (BOM) -->
        <div class="flex gap-3" *ngIf="bom === 1">
          <div class="flex-1">
            <label class="mb-1 block text-sm font-medium text-gray-700">Tatzeit bis - Datum *</label>
            <input type="text" inputmode="numeric" placeholder="TT.MM.JJJJ" formControlName="tatzeit_bis_datum" class="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500" />
          </div>
          <div class="w-[130px]">
            <label class="mb-1 block text-sm font-medium text-gray-700">Uhrzeit bis *</label>
            <input type="text" inputmode="numeric" placeholder="HH:MM" formControlName="tatzeit_bis_uhrzeit" class="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-blue-500 focus:ring-blue-500" />
          </div>
        </div>

        <p class="text-xs text-gray-400">Datum im Format TT.MM.JJJJ, Uhrzeit im Format HH:MM (24h).</p>
      </form>
    </div>

    <!-- ============================ STEP 3: IMAGES ============================ -->
    <div *ngIf="step === 3">
      <p class="mb-4 text-[15px] font-medium text-gray-700">
        Bilder hochladen (optional) &mdash; Aktenzeichen <strong>{{ aktenzeichen }}</strong>
      </p>
      <file-pond
        #pond
        [options]="pondOptions"
        [files]="pondFiles"
        (onprocessfile)="onPondProcess($event)"
        (onremovefile)="onPondRemove($event)">
      </file-pond>
      <p class="mt-3 text-sm text-gray-500">{{ uploadedImages }} Bild(er) hochgeladen.</p>
    </div>

    <!-- ============================ STEP 4: SUMMARY ============================ -->
    <div *ngIf="step === 4">
      <p class="mb-4 text-[15px] font-medium text-gray-700">Überblick</p>
      <div class="overflow-hidden rounded-lg border border-gray-200">
        <div class="flex justify-between gap-4 bg-gray-50 px-3.5 py-2.5">
          <span class="text-sm text-gray-500">Typ</span><strong class="text-sm text-gray-900">{{ typeLabel }}</strong>
        </div>
        <div class="flex justify-between gap-4 px-3.5 py-2.5">
          <span class="text-sm text-gray-500">Aktenzeichen</span><strong class="text-sm text-gray-900">{{ aktenzeichen }}</strong>
        </div>
        <div class="flex justify-between gap-4 bg-gray-50 px-3.5 py-2.5">
          <span class="text-sm text-gray-500">Kennzeichen</span>
          <strong class="text-right text-sm text-gray-900">{{ frm.value.kzland }} {{ frm.value.kzbezirk }} {{ frm.value.kznummer }}</strong>
        </div>
        <div class="flex justify-between gap-4 px-3.5 py-2.5">
          <span class="text-sm text-gray-500">Tatort</span>
          <strong class="text-right text-sm text-gray-900">{{ frm.value.street }} {{ frm.value.streetnbr }}</strong>
        </div>
        <div class="flex justify-between gap-4 bg-gray-50 px-3.5 py-2.5">
          <span class="text-sm text-gray-500">Hersteller / Farbe</span>
          <strong class="text-right text-sm text-gray-900">{{ frm.value.hersteller || '-' }} / {{ frm.value.farbe || '-' }}</strong>
        </div>
        <div class="flex justify-between gap-4 px-3.5 py-2.5">
          <span class="text-sm text-gray-500">Tatzeit{{ bom === 1 ? ' von' : '' }}</span>
          <strong class="text-right text-sm text-gray-900">{{ frm.value.tat_datum }} {{ frm.value.tat_zeit }}</strong>
        </div>
        <div class="flex justify-between gap-4 bg-gray-50 px-3.5 py-2.5" *ngIf="bom === 1">
          <span class="text-sm text-gray-500">Tatzeit bis</span>
          <strong class="text-right text-sm text-gray-900">{{ frm.value.tatzeit_bis_datum }} {{ frm.value.tatzeit_bis_uhrzeit }}</strong>
        </div>
        <div class="flex justify-between gap-4 px-3.5 py-2.5">
          <span class="text-sm text-gray-500">Bilder</span><strong class="text-sm text-gray-900">{{ uploadedImages }}</strong>
        </div>
      </div>
      <p class="mt-3 text-xs text-gray-500">
        Der Eintrag wird als <em>Entwurf</em> gespeichert. Tatbestand und weitere Details können anschließend in der
        Bearbeitung ergänzt werden.
      </p>
    </div>
  </div>

  <!-- footer -->
  <div class="mt-5 flex items-center gap-2 border-t border-gray-200 pt-4">
    <button
      type="button"
      *ngIf="step > 1"
      class="rounded-lg px-4 py-2 text-sm font-medium text-gray-600 hover:bg-gray-100 disabled:opacity-50"
      (click)="back()"
      [disabled]="reserving || saving">
      Zurück
    </button>
    <span class="flex-1"></span>
    <button
      type="button"
      class="rounded-lg px-4 py-2 text-sm font-medium text-gray-600 hover:bg-gray-100 disabled:opacity-50"
      (click)="cancel()"
      [disabled]="saving">
      Abbrechen
    </button>

    <button
      type="button"
      *ngIf="step === 1"
      class="rounded-lg bg-blue-600 px-5 py-2 text-sm font-medium text-white hover:bg-blue-700"
      (click)="goToInfo()">
      Weiter
    </button>

    <button
      type="button"
      *ngIf="step === 2"
      class="rounded-lg bg-blue-600 px-5 py-2 text-sm font-medium text-white hover:bg-blue-700 disabled:opacity-50"
      (click)="reserveAndContinue()"
      [disabled]="reserving">
      {{ reserving ? 'Bitte warten...' : 'Weiter' }}
    </button>

    <button
      type="button"
      *ngIf="step === 3"
      class="rounded-lg bg-blue-600 px-5 py-2 text-sm font-medium text-white hover:bg-blue-700"
      (click)="goToSummary()">
      Weiter
    </button>

    <button
      type="button"
      *ngIf="step === 4"
      class="rounded-lg bg-blue-600 px-5 py-2 text-sm font-medium text-white hover:bg-blue-700 disabled:opacity-50"
      (click)="save()"
      [disabled]="saving">
      {{ saving ? 'Speichern...' : 'Speichern' }}
    </button>
  </div>
</div>
